if (typeof window !== 'undefined' && typeof window.mnsFooterConfig !== 'undefined') {
    module.exports = window.mnsFooterConfig;
} else {
    module.exports = {
        "wcsBaseUrl": "/webapp/wcs/stores/servlet/",
        "CMD": {
            "contentAPI": "MSResFetchContentAjax"
        },
        "storeId": "10151",
        "langId": "-24",
        "catalogId": "10051"
    }
};


/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/data/config/app.js
 **/